import { Image } from 'react-native'
import { Images as foundationImages } from '@vfgroup-oneplatform/foundation/Components/Themes'

const Images = {
  ...foundationImages,
  //HIFI images
  tick: Image.resolveAssetSource(require('./../Images/Icons/HIFI/tick.png')),
  success: Image.resolveAssetSource(require('./../Images/Icons/HIFI/success.png')),
  warning: Image.resolveAssetSource(require('./../Images/Icons/HIFI/warning.png')),

  //icons
  smsText: Image.resolveAssetSource(require('./../Images/Icons/Icons/sms_text.png')),
  smsTextWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/sms_text_white.png')),
  landline: Image.resolveAssetSource(require('./../Images/Icons/Icons/landline.png')),
  landlineWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/landline_white.png')),
  dataSharing: Image.resolveAssetSource(require('./../Images/Icons/Icons/data_sharing.png')),
  dataSharingWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/data_sharing_white.png')),
  offerDefaultIcon: Image.resolveAssetSource(require('./../Images/Icons/Icons/offer_default_icon.png')),
  offerDefaultIconWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/offer_default_icon_white.png')),
  ic_chevron_up: Image.resolveAssetSource(require('./../Images/Icons/Icons/ic_chevron_up.png')),
  ic_chevron_down: Image.resolveAssetSource(require('./../Images/Icons/Icons/icChevronDown.png')),
  idCard: Image.resolveAssetSource(require('./../Images/Icons/Icons/idCard.png')),
  idCardWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/idCardWhite.png')),
  address: Image.resolveAssetSource(require('./../Images/Icons/Icons/address.png')),
  addressWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/addressWhite.png')),
  search: Image.resolveAssetSource(require('./../Images/Icons/Icons/search.png')),

  edit: Image.resolveAssetSource(require('./../Images/Icons/Icons/edit.png')),
  editOrange: Image.resolveAssetSource(require('./../Images/Icons/Icons/editOrange.png')),
  icLocationRed: Image.resolveAssetSource(require('./../Images/Icons/Icons/icLocationRed.png')),
  icLocationOrange: Image.resolveAssetSource(require('./../Images/Icons/Icons/icLocationOrange.png')),
  icLocationWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/icLocationWhite.png')),
  icLocationDark: Image.resolveAssetSource(require('./../Images/Icons/Icons/icLocationDark.png')),

  cloud: Image.resolveAssetSource(require('./../Images/Icons/Icons/cloud.png')),
  fix: Image.resolveAssetSource(require('./../Images/Icons/Icons/fix.png')),
  iot: Image.resolveAssetSource(require('./../Images/Icons/Icons/iot.png')),
  mobile: Image.resolveAssetSource(require('./../Images/Icons/Icons/mobile.png')),
  cloud_dark: Image.resolveAssetSource(require('./../Images/Icons/Icons/cloud_dark.png')),
  fix_dark: Image.resolveAssetSource(require('./../Images/Icons/Icons/fix_dark.png')),
  iot_dark: Image.resolveAssetSource(require('./../Images/Icons/Icons/iot_dark.png')),
  mobile_dark: Image.resolveAssetSource(require('./../Images/Icons/Icons/mobile_dark.png')),

  health: Image.resolveAssetSource(require('./../Images/Icons/Icons/health.png')),
  repair: Image.resolveAssetSource(require('./../Images/Icons/Icons/repair.png')),
  product: Image.resolveAssetSource(require('./../Images/Icons/Icons/product.png')),
  health_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/health_white.png')),
  repair_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/repair_white.png')),
  product_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/product_white.png')),
  store: Image.resolveAssetSource(require('./../Images/Icons/Icons/store.png')),
}

export default Images
